import BaseModel from "./BaseModel";
import StudentBaseModel from "./StudentBaseModel";

export default class CreditsModel extends BaseModel {
  amount?: number;
  student?: StudentBaseModel;
  description?: string;
  constructor(arg: any) {
    super(arg);
    this.description = arg?.description;
    this.amount = arg?.amount;
    this.student =  StudentBaseModel.fromApiResponse(arg?.student);
  }
}
